import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFilterUsers } from "./hooks/useFilterUsers";
import { RootState } from "../../app/store";
import { loadUsers } from "./slices/usersSlice";
import { Header } from "./components/Header";
import { UsersTable } from "./components/UsersTable";
import { useGetAllUsers } from "./hooks/useGetAllUsers";
import { DeleteUser } from "./components/DeleteUser";
import { useAuth } from "../authentication/hooks/useAuth";
import UserFormDrawer from "./components/UserFormDrawer";
import { IUsersData } from "./slices/usersSlice";

export const Users = () => {
  const { user } = useAuth();
  const users = useSelector((state: RootState) => state.users);
  const { usersfiltered, filter } = useFilterUsers(users?.users, Number(user?.data?.idarea));
  const dispatch = useDispatch();
  const [openDelete, setOpenDelete] = useState(false);
  const [usernameDelete, setUsernameDelete] = useState('');
  const { data: usersData, isLoading, refetch } = useGetAllUsers(filter);
  
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<IUsersData | undefined>();

  useEffect(() => {
    const getUsers = async () => {
      if (!isLoading && usersData && filter !== 11) {
        dispatch(loadUsers(usersData));
      }
    };
    getUsers();

    return () => {
      dispatch(loadUsers({ success: false, message: "", data: [] }));
    };
  }, [filter, isLoading, dispatch, usersData]);

  const handleInactivateUser = async (username: string): Promise<void> => {
    setOpenDelete(true);
    setUsernameDelete(username);
  };

  const handleOpenDrawer = (userData?: IUsersData) => {
    setSelectedUser(userData);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedUser(undefined);
  };

  return (
    <>
      <Header
        saveNewItem={() => handleOpenDrawer()}
        title="module_users.module_title"
        buttonText="module_users.module_button_create"
      />
      <UserFormDrawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        dataUser={selectedUser}
        refetchUsers={refetch}
      />
      <UsersTable
        users={usersfiltered}
        inacUser={handleInactivateUser}
        filter={filter}
        onEditUser={handleOpenDrawer}
      />
      <DeleteUser
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        usernameDelete={usernameDelete}
        refetch={refetch}
      />
    </>
  );
};
